import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import ItemsSelectFieldStandalone from "../../forms/stand-alone-select-field";
import { useFormikContext } from "formik";
import AddButton from "../../buttons/button";
import CloseIcon from "../../../assets/icons/close-icon";
import { useDispatch } from "react-redux";
import LoadingOverlay from "../../helper-components/overlay-loading";
import { invoiceProdDetailsAction } from "../../../redux/actions/invoices-action";
import moment from "moment";

export default function BatchDetailsPanel({
  open,
  setOpen,
  selectedItem,
  setSelectedItem,
}) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { values } = useFormikContext();

  const batchDetails = values?.stockAuditRecordData?.find(
    (item) =>
      item?.item_batch_number === selectedItem?.item_batch_number &&
      item?.item_id === selectedItem?.itemid
  );

  const productList = Array.isArray(values?.stockAuditRecordData)
    ? values.stockAuditRecordData.map((item) => ({
        label: item?.item_batch_number ?? "",
        value: item?.item_batch_number ?? "",
        item_id: item?.item_id ?? "",
      }))
    : [];

  const InfoRow = ({ label, value, className = "" }) => (
    <div className={`flex flex-col gap-1 ${className}`}>
      <div className="text-[var(--slide-panel-label)] text-[length:var(--slide-panel-label-fs)] font-[var(--slide-label-value-fw)]">
        {label}
      </div>
      <div className="text-[var(--slide-panel-value)] text-[length:var(--slide-panel-value-fs)] font-[var(--slide-panel-value-fw)] text-wrap">
        {value || "-"}
      </div>
    </div>
  );

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={() => {
          setOpen(false);
          // setbatchDetails({ item_id: "" });
        }}
      >
        <div className="fixed inset-0 overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="absolute inset-0 bg-[#0000004D]" />
          </Transition.Child>

          <div className="fixed inset-0 flex justify-end">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-300"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-300"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <Dialog.Panel className="h-full w-[400px] sm:w-[700px] bg-white overflow-y-auto rounded-tl-lg rounded-bl-lg shadow-xl">
                {/* Header */}
                <div
                  className="h-[61px] bg-[var(--slide-panel-head-bg)] px-3 flex items-center justify-between border-b"
                  style={{ borderColor: "var(--slide-panel-border)" }}
                >
                  <div className="min-w-[75%]">
                    <ItemsSelectFieldStandalone
                    labelClass={"w-[8rem]"}
                      fieldClass="w-[75%]"
                      name="uom"
                      label="Batch Details"
                      isLabelReq
                      value={batchDetails?.item_batch_number}
                      onChange={(sel) => {
                        setSelectedItem((prev) => ({
                          ...prev,
                          itemid: sel?.item_id,
                          item_batch_number: sel?.value,
                        }));
                      }}
                      options={productList}
                    />
                  </div>
                  <AddButton
                    onclkFn={() => {
                      setOpen(false);
                      // setbatchDetails({ item_id: "" });
                    }}
                    icon={
                      <CloseIcon
                        width="12px"
                        height="12px"
                        fill="var(--close-button-fg)"
                      />
                    }
                    text={
                      <span>
                        Close <span className="opacity-50">(X)</span>{" "}
                      </span>
                    }
                    className="flex h-[32px]  items-center gap-2 bg-[var(--close-button-bg)] border-radius px-3 text-[var(--close-button-fg)]"
                  />
                </div>

                {/* Product Detail Panel */}
                <div
                  style={{
                    maxHeight: `calc(100% - 61px)`,
                    minHeight: `calc(100% - 61px)`,
                  }}
                  className="p-4 overflow-y-auto"
                >
                  <div className="space-y-5 border border-[var(--slide-panel-border)] border-radius p-4">
                    <div className="flex ">
                      <div className="border-b border-b-[var(--slide-panel-border)]  space-y-5 py-3 w-[50%]">
                        <InfoRow
                          label="Product Name"
                          value={batchDetails?.item_name}
                        />
                        <InfoRow
                          label="Batch Number"
                          value={
                            <span className={`text-[var(--success-color)]`}>
                              {batchDetails?.item_batch_number}
                            </span>
                          }
                        />
                        <InfoRow label="UOM" value={batchDetails?.item_uom} />
                      </div>
                      <div className="border-b border-b-[var(--slide-panel-border)] flex items-end  space-y-5 py-3 w-[50%]">
                        <InfoRow
                          label="Expiry"
                          value={
                            batchDetails?.item_exp_date ? (
                              moment(batchDetails.item_exp_date).isAfter(
                                moment()
                              ) ? (
                                <span className="text-[var(--success-color)]">
                                  {moment(batchDetails.item_exp_date).format(
                                    "DD/MM/YYYY"
                                  )}
                                </span>
                              ) : (
                                <span className="text-[var(--error-color)]">
                                  {moment(batchDetails.item_exp_date).format(
                                    "DD/MM/YYYY"
                                  )}
                                </span>
                              )
                            ) : (
                              "-"
                            )
                          }
                        />
                      </div>
                    </div>

                    <div className="flex">
                      <div className=" flex flex-col gap-5 py-3 w-[50%]">
                        <InfoRow
                          label="System Quantity "
                          value={batchDetails?.item_quantity}
                        />

                        <InfoRow
                          label="Physical Quantity"
                          value={batchDetails?.updated_quantity}
                        />
                        <InfoRow
                          label="Difference"
                          value={
                            <span
                              className={`${
                                parseFloat(
                                  batchDetails?.item_correction_quantity
                                ) > 0
                                  ? "text-[var(--success-color)]"
                                  : "text-[var(--error-color)]"
                              }`}
                            >
                              {batchDetails?.item_correction_quantity}
                            </span>
                          }
                        />
                      </div>
                      <div className=" flex flex-col gap-5 w-[50%] py-3">
                        <InfoRow
                          label="Current Value"
                          value={batchDetails?.item_current_amount}
                        />
                        <InfoRow
                          label="Adjusted Value"
                          value={batchDetails?.item_adjusted_amount}
                        />
                        <InfoRow
                          label="Difference"
                          value={
                            <span
                              className={`${
                                parseFloat(
                                  batchDetails?.item_current_adjusted_diff
                                ) > 0
                                  ? "text-[var(--success-color)]"
                                  : "text-[var(--error-color)]"
                              }`}
                            >
                              {batchDetails?.item_current_adjusted_diff}
                            </span>
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <LoadingOverlay isLoading={loading} />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
